import * as React from 'react';
import { Box, Button, DialogActions, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { ReactComponent as ExitIcon } from '../../images/x-window.svg';
import { COLORS } from '../../constants/constants';
interface DialogButton {
    color?: any;
    name: string | JSX.Element;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    disabled?: boolean;
    startIcon?: JSX.Element;
    styles?: React.CSSProperties;
}

interface MuiDialogWrapperProps {
    title?: string | JSX.Element;
    content: any;
    buttons?: Array<DialogButton>;
    onClose?: React.MouseEventHandler<HTMLButtonElement>;
    styles?: Object;
    contentStyles?: Object;
    titleStyles?: Object;
    divider?: boolean;
    removeBoxShadoe?: boolean;
    showExitButton?: boolean;
    prefixCloseWindow?: any;
}

const MuiDialogWrapper: React.FC<MuiDialogWrapperProps> = ({
    title,
    content,
    buttons,
    onClose,
    styles,
    contentStyles,
    divider,
    titleStyles,
    showExitButton = true,
    prefixCloseWindow,
}) => (
    <Box sx={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', ...styles }} data-testid="dialog">
        <Box
            className="background-color-l"
            sx={{ display: 'flex', justifyContent: 'space-between', position: 'sticky', zIndex: 4, top: 0 }}
        >
            <DialogTitle sx={{ flexGrow: 1, ...titleStyles }}>{title}</DialogTitle>
            <Box
                sx={{
                    top: '15px',
                    right: '22px',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    height: 'fit-content',
                }}
            >
                {prefixCloseWindow ? prefixCloseWindow : ''}
                {showExitButton && (
                    <IconButton
                        sx={{
                            width: '28px',
                            height: '28px',
                        }}
                        onClick={(e) => onClose?.(e)}
                    >
                        <ExitIcon />
                    </IconButton>
                )}
            </Box>
        </Box>

        <DialogContent sx={{ borderBottom: 'unset', overflow: 'auto', ...contentStyles }} dividers={divider}>
            {content}
        </DialogContent>
        {buttons && (
            <DialogActions sx={{ borderTop: `2px solid ${COLORS.MUTED_SOFT}` }}>
                {buttons?.map((button, index) => (
                    <Button
                        startIcon={button.startIcon ? button.startIcon : null}
                        key={index}
                        sx={{ height: '40px', ...button.styles }}
                        size="small"
                        color={button.color ? button.color : 'primary'}
                        onClick={button.onClick || onClose}
                        disabled={button.disabled || false}
                    >
                        {button.name}
                    </Button>
                ))}
            </DialogActions>
        )}
    </Box>
);

export default MuiDialogWrapper;
